import { type AnyHTMLInputElementType, isString } from "@mcwd/typescript-type-guards";

const InputValueChangeEventName = "inputValueChange" as const;

const dataInputValueChangeListenerIdAttr = "data-input-value-change-listener-id" as const;

const inputValueChangeEvent = new Event(InputValueChangeEventName);
const trackedInputs = new Map<string, number>();

function removeInputChangeListener(elementOrGuid: AnyHTMLInputElementType | string) {
  const inputGuid = isString(elementOrGuid) ? elementOrGuid : elementOrGuid.getAttribute(dataInputValueChangeListenerIdAttr) ?? "";
  if (inputGuid !== "") {
    const intervalVal = trackedInputs.get(inputGuid) ?? null;
    if (intervalVal !== null) {
      clearInterval(intervalVal);
      trackedInputs.delete(inputGuid);
    }
  }
}

function registerInputChangeListener (element: AnyHTMLInputElementType): string {
  let prevVal = element.value;

  const inputGuid = "GUID-" + crypto.randomUUID();

  element.setAttribute(dataInputValueChangeListenerIdAttr, inputGuid);
  trackedInputs.set(inputGuid, setInterval(function () {
    if (document.querySelectorAll(`[${dataInputValueChangeListenerIdAttr}='${inputGuid}']`).length === 0) {
      //remove listener, if the element no longer exists
      removeInputChangeListener(inputGuid);
    }
    else {
      const newVal = element.value;
      if (newVal !== prevVal) {
        prevVal = newVal;
        element.setAttribute("value", newVal);
        element.dispatchEvent(inputValueChangeEvent);
      }
    }
  }, 100));
  return inputGuid;
}

export const inputValueChangedListener = {
  addInput: registerInputChangeListener,
  removeInput: removeInputChangeListener,
  eventName: InputValueChangeEventName
};

// //example
// inputValueChangedListener.addInput(document.getElementById("test") as AnyHTMLInputElementType); //init observer
// document.getElementById("test")?.addEventListener(inputValueChangedListener.eventName, function (this: AnyHTMLInputElementType) {
//   console.log("element has new value: " + this.value);
// });